"use client";

import { PricingTable as PricingTablePrimitive } from "@shared/components/PricingTable";
import { apiClient } from "@shared/lib/api-client";
import type { ApiOutput } from "api/trpc/router";
import { useTranslations } from "next-intl";
import { getCookie } from "cookies-next";

export function PricingTable({
  plans,
}: {
  plans: ApiOutput["billing"]["plans"];
}) {
  const t = useTranslations();

  const createCheckoutLinkMutation =
    apiClient.billing.createCheckoutLink.useMutation();

  return (
    <PricingTablePrimitive
      plans={plans}
      onSelectPlan={async (planId, variantId) => {
        try {
          const posthogDistinctId = JSON.parse(
            (await getCookie(
              `ph_${process.env.NEXT_PUBLIC_POSTHOG_KEY}_posthog`
            )) as string
          ).distinct_id;

          const checkoutLink = await createCheckoutLinkMutation.mutateAsync({
            planId,
            variantId,
            ShouldCreateUser: true,
            teamId: "",
            redirectUrl: `${window.location.origin}/onboarding/welcome`,
            posthogDistinctId,
          });

          window.location.href = checkoutLink;
        } catch (error) {
          console.error(error);
        }
      }}
      labels={{
        year: t("pricing.year"),
        month: t("pricing.month"),
        yearly: t("pricing.yearly"),
        monthly: t("pricing.monthly"),
        subscribe: t("pricing.subscribe"),
      }}
    />
  );
}
